import { useRouter } from 'next/router';
import type { ROUTES } from '../../constants/urls';

export function useGetListingAlias() {
  const router = useRouter<typeof ROUTES.LISTING>();
  const { listingAlias } = router.query;
  return typeof listingAlias === 'string' ? listingAlias : '';
}

export function useGetApplicationRouteQuery() {
  const router = useRouter<typeof ROUTES.APPLICATION>();
  const { listingAlias, applicationId } = router.query;
  return {
    listingAlias: typeof listingAlias === 'string' ? listingAlias : '',
    applicationId: typeof applicationId === 'string' ? applicationId : '',
  };
}
